import React, { Fragment } from "react"

const Search = () => {
  return (
    <Fragment>
      <div className="app-view-body">Search</div>{" "}
      {/* <div className="app-view-extra ls"></div> */}
    </Fragment>
  )
}

export default Search
